<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="6" class="text-start">
                                <strong>Vehicle Reallocation</strong>
                            </b-col>
                        </b-row>
                    </div>

                    <div>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group label="From Date :"  :label-cols="3" >
                                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                                 </v-date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="To Date :"  :label-cols="3" >
                                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: selectDateFrom, end: null }' v-model='selectDateTo'>
                                  </v-date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group  label="Select Vehicle :" :label-cols="4" class="mb-4">
                                    <v-select v-model="selected_vehicleno" @input="selectsearchvehicle(selected_vehicleno)" :options="vehicleitems" placeholder="-- Select Vehicle NO --"></v-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group >
                                    <b-form-textarea v-model="searching" rows="3" placeholder="Type to Search : 1023,Test"  @input="checklenght(searching)"></b-form-textarea>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-button variant="primary" size="md" @click="getReallocationList(pageNum)">Search</b-button>
                                &nbsp;
                                <b-button variant="danger" size="md" @click="clear()">Clear</b-button>
                                &nbsp;
                                <a :href="downloadcsv" target="_blank" rel="noopener noreferrer" v-if="totalRows>0">
                                    <b-button variant="primary" size="md" @click="getDownload()">Download</b-button>
                                </a>
                            </b-col>
                        </b-row>
                    </div>

                    <div>
                        <b-row>
                            <b-col md="12" class="text-right">
                                <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
                            </b-col>
                            <b-col md="12">
                                <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>  
                                    <template slot="mpscount" slot-scope="row">
                                        <button v-b-tooltip.hover title="View Count Details" @click="viewProduct(row.item)" style="background-color:white !important;" class="btn btn-link"  v-if="row.item.mpscount !=''">
                                              <span style="color:#1b8eb7"> {{row.item.mpscount}}</span>
                                           </button>
                                      </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col sm="12" class="text-right">
                          <!-- <br> -->
                               <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                        </b-col>
                        <b-col md="12" class="my-1" >
                            <paginate 
                                :page-count="noofpages"
                                :page-range="10"
                                :margin-pages="2"
                                :click-handler="clickCallback"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination'"
                                :page-class="'page-item'">
                            </paginate>
                        </b-col>   
                    </b-row> 

                    <b-modal size="lg" title="MPS Count Details" v-model="productdetailsModal" @ok="productdetailsModal = false" hide-footer>
                        <template slot="default" slot-scope="{ hide }">
                        <b-row>
                        <b-col sm="12" class="text-right">
                                <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                                </b-col>   
                                <div style="float: left;">
                                  <!-- v-if="this.mpstotalRows > 0" -->
                                  <span class="badge ml-2" 
                                  style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 3px;">DB</span> Damage Box&nbsp;&nbsp;
                                  <span class="badge ml-2" 
                              style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
                                </div>
                        <b-col sm="12"> 
                          <!-- <b-col sm="12"> -->
                        <b-table show-empty responsive  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusymps" >
                          <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div> 
                            <template slot="shippingid" slot-scope="row">
                              <span>{{row.item.shippingid}}</span>
                              <br>
                              <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding: 3px;cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                              &nbsp;
                              <span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px;cursor: pointer;">SB</span>
                            </template>
                            <template slot="mpsvalue" slot-scope="row">
                                  <span>&#8377; {{row.item.mpsvalue}} </span>
                                </template> 
                          <template slot="physicalweight" slot-scope="row">
                                  <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                                </template>
                                <template slot="physicalweight" slot-scope="row">
                                  <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                                </template>
                                <template slot="breadth" slot-scope="row">
                                  <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                                </template>
                                <template slot="length" slot-scope="row">
                                  <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                                </template>
                                <template slot="height" slot-scope="row">
                                  <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                                </template>
                              
                        </b-table> 
                      <!-- </b-col> -->
                      </b-col>
                      </b-row> 
                        <b-row>
                        <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                          <b-pagination
                                v-model="mpscurrentPage"
                                :total-rows="mpstotalRows"
                                :per-page="mpsperPage"
                                class="my-0"
                              ></b-pagination>
                        </b-col> 
                      </b-row>
                    </template>
                    </b-modal>

                    <b-modal size="md" id="defective_image_modal" title="Defective Image" hide-footer>
                        <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
                          No Record Found
                        </div>
                        <div v-else class="text-center">
                          <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
                        </div>
                      </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
    data() {
        return {
            listloader : false,
            // list 
            isBusy : false,
            RBZone_list : [],
            totalRows : 0,
            items:[],
            fields:[
                {key:'loadid', label:'Load ID'},
                { key: 'accounttype', label: 'Account Type'},
                {key:'invoicevalue', label:'Invoice Value'},
                {key:'mpscount', label:'MPS count'},
                {key:'shippingreferenceno', label:'Shipping Reference Number'},
                {key:'userid', label:'User ID'},
                {key:'destinationcompanyname', label:'Shipping Company'},
                {key:'destinationcity',label:'Destination City'},
                {key:'hub_city',label:'Vehicle Hub City'},
                {key:'vehicle_no',label:'Vehicle Number'},
                {key:'reallocated_vehicle_no', label:'Reallocated to'},
                {key:'reallocated_by',label:'Reallocated by'},
                {key:'reallocation_datetime',label:'Reallocation Date/time'},
                {key:'reason',label:'Reallocation Reason'}
            ],
            currentPage: 1,
            perPage:  20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,

            // Search 
            selectDateFrom: new Date(),
            selectDateTo:  new Date(),

            data: [],
            vehicleitems : [],
            selected_vehicleno : '',
            searching : [],
            downloadcsv : '',


            // mps 
            mpsfields:[
            // { key: 'mpsid', label: 'MPS Id', sortable: true, sortDirection: 'desc' },
            
            { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
            { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
            { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
            { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
                
                { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
            { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
            { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
            
                
            ],
            mpsitems:[],
            isBusymps:false,
            productdetailsModal:false,
            selected_user_details : '',

        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("YUUUUU", userInfo);
        this.displaydata()
        this.getReallocationList(this.pageNum);
    },

    methods: {

        checklenght(value){
            if (value.length==0) {
                this.searching=[];
                this.totalRows=0;
                this.getReallocationList(this.pageNum);
            }
        },

        displaydata: function() {

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.vehicleitems=[];
            const deliveryagentobj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                usertype: `${userInfo.user_type}`,
                isactive: "1",
                vehicle_type: "bulkreallocate",
            };
            console.log("deliveryagentobj", deliveryagentobj);
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`,
            deliveryagentobj).then((result) => {
                if (result.body.length > 0) {
                    this.data = result.body;
                    this.vehicleitems = result.body;
                    var data = [];

                    result.body.forEach(function (srData) {
                        data.push({
                        key:srData.vehicle_id,
                        label:srData.vehicle_no
                        });
                    });
                    this.vehicleitems = data;
                } else {
                    this.data = result.body;
                    this.vehicleitems = result.body;
                }
            })
            .catch((ex) => {
            console.log("error", ex);
            });
        },

        selectsearchvehicle(value_vehicle) {
            if(value_vehicle==null){
                this.selected_vehicleno="";
                this.getReallocationList(this.pageNum);
            }
            console.log("value_vehicle : ",value_vehicle);
        },

        clickCallback (pageNum){
        
        this.getReallocationList(pageNum);
        },

        getReallocationList(pageNum){
            this.items =[];
            this.totalRows=0;
            this.isBusy=true;

            if (this.searching.length>0) {
                var searching_data = []

                searching_data = this.searching.split(/[','|' '|'\n']/)

            }
    
            const Obj = {
                page_no : pageNum,
                fromDate : this.selectDateFrom.toISOString().slice(0, 10),
                toDate : this.selectDateTo.toISOString().slice(0, 10),
                vehicle_id : this.selected_vehicleno!=''? `${this.selected_vehicleno.key}`: '',
                search_text :this.searching.length>0?searching_data:this.searching, 
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getReallocatedAwbMaster`,Obj)
            .then((result)=>{
                console.log(result)
                this.isBusy=false;
                if (result.body.returnmsg=="Successful") {
                    this.items = result.body.returnvalue;
                    this.totalRows = result.body.returnvalue[0].totalcount;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
                }
                else{
                    this.items =[];
                    this.totalRows=0;
                }
            })
        },
        
        clear(){
            this.selectDateFrom = new Date();
            this.selectDateTo = new Date();
            this.searching=[];
            this.selected_vehicleno="";
            this.displaydata()
            this.getReallocationList(this.pageNum);
        },


        getDownload() {
            if (this.searching.length > 0) {
                var searching_data = [];
                searching_data = this.searching.split(/[','|' '|'\n']/);
            }

            this.downloadcsv = `${CONSTANTS.MIGRATION_API_URL}/getCsvReallocatedAwbMaster?fromDate=` + this.selectDateFrom.toISOString().slice(0, 10) + `&&` + `toDate=` + this.selectDateTo.toISOString().slice(0, 10) + `&&` + `vehicle_id=` + (this.selected_vehicleno != '' ? `${this.selected_vehicleno.key}` : '') + `&&` + `search_text=` + (this.searching.length > 0 ? JSON.stringify(searching_data) : this.searching);

        },

        viewProduct:function(value){
            this.mpsitems  = [];
                 this.mpstotalRows = 0;
          this.mpscurrentPage=1;
          this.productdetailsModal=true;
          this.isBusymps = true;
        // console.log("value",value);
        let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
       
        
         
        let obj = {
          parentawb: value.loadid,
        }
        this.$http
            .post(
              `${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
            .then(result => {
              // console.log(result.body);
                this.isBusymps = false;
                if(result.body.returnmsg === "successful"){
                 
                 this.mpsitems  = result.body.returnvalue;
                 // console.log("HHHHH",this.mpsitems);
                  this.mpstotalRows = result.body.returnvalue.length
                  // console.log("RRRRR",this.mpsitems);
                 
                }else {
                 this.mpsitems  = [];
                 this.mpstotalRows = 0;
                }
            }).catch(ex => {
              console.log('error', ex)
            })
          
      },
      Viewimagedetails : function (data){
            this.selected_user_details=data;
            console.log("rrrrrrrrrrr",this.selected_user_details);
        },
    },
}
</script>

<style scoped>
.nav-tabs .nav-link.active {
    color: #2f353a;
    background: #fff;
    border-color: #c8ced3;
    border-bottom-color: #fff;
    font-weight: bold;
}
</style>